import { Icon } from "@zambezi/sdk/icons"
import React, { FC } from "react"
import { HeroTagProps } from "./Hero.types"

const HeroTag: FC<HeroTagProps> = ({
    text,
    icon,
    iconProps,
    ...props
}: HeroTagProps) => {
    return (
        <span className="zb-hero-tag" {...props}>
            {icon && <Icon name={icon} title="" {...iconProps} />}
            <span>{text}</span>
        </span>
    )
}

export default HeroTag
